<!-- All class in this HTML are invalid BEM naming convention -->
<div *ngIf="tagList" class="promo__content__tags__wrapper">
    <div *ngIf="tagTitle"
         class="promo__content__tags__title">
      {{ tagTitle() }}
    </div>
    <div class="promo__content__tags__body scroll__content__tags">
      @for (tag of tagList(); track $index) {
        <button type="button" class="promo__content__tags" (click)="onTagClick(tag)">{{ tag }}</button>
      }
    </div>
  </div>
